import { gql } from 'apollo-angular';

export const USER_PASSWORD_APTITUDE_ORGS = gql`
  query UserPasswordAptitudeOrgs($username: String!, $password: String!) {
    userPasswordAptitudeOrgs(username: $username, password: $password) {
      id
      name
    }
  }
`;

export type UserPasswordAptitudeOrgsVariables = {
  username: string;
  password: string;
};
